const dev = {
    API_ENDPOINT_URL: 'http://localhost:3001/api/',
    FILES_URL: 'http://localhost:3001/',
    AUTH_URL: 'http://localhost:3001/api/'
};

const prod = {
    API_ENDPOINT_URL: '/',     // relative path
    FILES_URL: '/',        // relative path
    AUTH_URL: '/api/'
};

const test = {
    API_ENDPOINT_URL: '',
    FILES_URL: '',
};

const getEnv = () => {
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev;
        case 'production':
            return prod;
        case 'test':
            return test;
        default:
            break;
    }
};

export const env = getEnv();
